import { render } from "./Barsetshire.vue?vue&type=template&id=71c65c6a&scoped=true"
import script from "./Barsetshire.vue?vue&type=script&lang=js"
export * from "./Barsetshire.vue?vue&type=script&lang=js"

import "./Barsetshire.vue?vue&type=style&index=0&id=71c65c6a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-71c65c6a"

export default script